module.exports = __webpack_public_path__ + "static/img/surveys.7a25b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/surveys.png
// module id = q/mD
// module chunks = 0